import gql from "graphql-tag";

export const CLUB_MEMBERSHIP_FORM = gql`
  mutation sendFormDetails(
    $date: DateTime!
    $clubName: String!
    $contactName: String!
    $numberOfMember: Float!
    $phoneNumber: Float!
    $email: String!
    $address: String!
    $city: String!
    $state: String!
    $postCode: Float!
    $abn: String!
  ) {
    sendFormDetails(
      input: {
        date: $date
        clubName: $clubName
        contactName: $contactName
        numberOfMember: $numberOfMember
        phoneNumber: $phoneNumber
        email: $email
        address: $address
        city: $city
        state: $state
        postCode: $postCode
        abn: $abn
      }
    ) {
      statusCode
      success
      message
    }
  }
`;
